import Tree from './Tree';

export default Tree;



// WEBPACK FOOTER //
// ./src/components/common/control/tree/index.js